import { useRef } from 'react';
import { useInView } from 'framer-motion';

import { Background } from './Background';
import { GoogleAds } from './GoogleAds';
import { Headshot } from './Headshot';
import { Options } from './Options';
import { Regulated } from './Regulated';

export function MobileAnimation() {
  const containerRef = useRef<HTMLElement>(null);

  const isInView = useInView(containerRef, { once: true, amount: 0.3 });

  return (
    <section
      ref={containerRef}
      className="overflow-hidden rounded-16 relative mx-auto"
    >
      <div className="relative z-3 w-full">
        <Headshot
          name="Sherry J."
          title="Privacy"
          headshotUrl="https://cdn.sanity.io/images/ztw74qc4/production/6b1e9dfb4eed56d70799e357ee3f518583b883df-432x431.png"
          className="absolute m:top-60 top-12 s:top-5 right-30 s:right-5 m:right-initial m:left-[17%] z-20  min-[500px]:right-30 min-[500px]:top-40"
          shouldAnimate={isInView}
        />
        <Headshot
          name="Zahir M."
          title="Marketing"
          headshotUrl="https://cdn.sanity.io/images/ztw74qc4/production/17f7fff3aabddb7fd6e021138b479aed589edf29-432x431.png"
          className="absolute m:bottom-60 top-80 s:top-70 left-20 m:left-initial m:right-[18%] z-20"
          shouldAnimate={isInView}
          additionalMobileDelay={0.15}
        />
        <GoogleAds shouldAnimate={isInView} />
        <Regulated shouldAnimate={isInView} />
        <Options shouldAnimate={isInView} />
        <div className="m:h-[300px] h-[85vw] w-[100vw] m:w-1" />
      </div>
      <Background className="absolute -bottom-10 -right-10 -left-10 -top-10 z-1 scale-110" />
    </section>
  );
}
